<template>
    <v-group :config="groupConfig">
        <LineWithRibsPart v-for="linePart in lineParts"
                          :key="linePart.id"
                          :id="linePart.id"
                          :type="type"
                          :fromPoint="linePart.fromPoint"
                          :toPoint="linePart.toPoint"
                          :lineLengthIsHidden="lineLengthIsHidden"
                          :baseLine="line"
                          :lineColor="color"
                          :lineColorHover="lineColorHover"
                          :sizeFlip="lineSizeFlipped"
        ></LineWithRibsPart>

        <LineRib v-for="ribFromPoint in lineRibs"
                 :key="ribFromPoint.id"
                 :x="ribFromPoint.x"
                 :y="ribFromPoint.y"
                 :ribsSideCoefficient="ribsSideCoefficient"
                 :lineColor="color"
        ></LineRib>

        <v-text v-if="!lineLengthIsHidden" :config="lineLengthTextConfig"></v-text>
    </v-group>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import LineRib from "./LineRib";
    import LineWithRibsPart from "./LineWithRibsPart";

    export default {
        name: "LineWithRibs",

        components: {
            LineWithRibsPart,
            LineRib,
        },

        props: [
            'id',
            'type',
            'fromPoint',
            'toPoint',
            'lineLengthIsHidden',
            'ribLinePoints',
            'lineColor',
            'lineColorHover',
        ],

        computed: {
            ...mapState('editor', [
                'drawingState',
            ]),

            ...mapState('paint', [
                'paintSide',
            ]),

            ...mapGetters('editor', [
                'getFootsInFractions',
            ]),

            ...mapGetters('line', [
                'getLineByPoints',
                'getLineWithRibsStartingLength',
            ]),

            line() {
                return this.getLineByPoints(this.fromPoint, this.toPoint);
            },

            groupConfig() {
                let dx = this.toPoint.x - this.fromPoint.x;
                let x, y, rotation;

                // check the start point direction
                if (dx >= 0) {
                    x = this.fromPoint.x;
                    y = this.fromPoint.y;
                    rotation = this.line.angle360;
                }
                else {
                    x = this.toPoint.x;
                    y = this.toPoint.y;
                    rotation = this.line.angle360 - 180;
                }

                return {
                    x,
                    y,
                    rotation,
                }
            },

            lineParts() {
                let lines = [];

                // line parts around and between the ribs
                for (let i = 0; i < this.ribLinePoints.length; i += 2) {
                    let fromPoint = this.ribLinePoints[i];
                    let toPoint = this.ribLinePoints[i+1];
                    let id = fromPoint.id;

                    let line = {
                        id,
                        fromPoint,
                        toPoint,
                    };

                    lines.push(line);
                }

                return lines;
            },

            lineRibs() {
                let ribs = [];

                // parts are between the ribs
                for (let i = 0; i < this.lineParts.length - 1; i++) {
                    let ribFromPoint = this.lineParts[i].toPoint;

                    ribs.push(ribFromPoint);
                }

                return ribs;
            },

            ribsSideCoefficient() {
                let dx = this.toPoint.x - this.fromPoint.x;

                // ribs side direction depends to the paint side and the line direction (dx >= 0)
                let sideDirection = this.paintSide == dx >= 0;

                return sideDirection ? 1 : -1;
            },

            lineLengthTextConfig() {
                let lineStartingLength = this.getLineWithRibsStartingLength(this.line);

                let text = this.getFootsInFractions(lineStartingLength);

                let y = this.lineSizeFlipped ? 9 : -21;

                return {
                    x: 5,
                    y,
                    text,
                    fontSize: 12,
                    fontFamily: 'Arial',
                    fontStyle: 'bold',
                    fill: '#555555',
                    // use text shadow to make contrast on the dark background, e.g. dark paint brush
                    shadowColor: 'white',
                    shadowOffset: { x: 1, y: 1 },
                    shadowOpacity: 0.3,
                }
            },

            lineSizeFlipped() {
                return this.fromPoint['sizeFlip'];
            },

            isHovered() {
                return this.fromPoint['isLineHover'];
            },

            color() {
                let hovered = !this.drawingState && this.isHovered;

                return hovered ? this.lineColorHover : this.lineColor;
            },

        },

    }
</script>

<style scoped>

</style>